<template>
  <v-col lg="10">
    <div v-if="loading">
    <Loading/>
    </div>
    <v-container v-if="!loading">
      <v-row>
        <v-col>
          Quote <span class="primary--text">#{{  + Number.parseInt(order+1) }}</span>
        </v-col>
      </v-row>
      <div v-if="$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col style="display: block;">
            <h1 class="mb-4">Here's your quote</h1>
        </v-col>
        </v-row>
        <v-row style="display: block;">
          <v-col>
            <v-card elevation="10" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Delivery</h2>
                    <h2 v-else class="black--text mb-4">Collection</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2><span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span> ex VAT)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p v-if="!isTruckVehicle">
                      Bin placement, collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                    <p v-else>
                      Collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="!isTruckVehicle">
            <v-card elevation="0" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Exchange</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span> ex VAT)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>
                      Full bin collection and bring a new bin (exchange)
                      Bin exchange, disposal and landfill dump charges* (VAT inclusive)
                      Skip bin rental for 1- 7 days
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br/><br/>
        <v-row>
          <v-col>
            Quote details
          </v-col>
          <v-col align="end">
            #{{ parseInt(order+1) }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row style="display: block;">
          <v-col>
            <h4 class="black--text mb-2">Your waste address is </h4>
            {{ capturedAddress }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Waste type </h4>
            {{ wasteType.name }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Service type </h4>
            <span> {{ vehicle.name }} </span>
          </v-col>
        </v-row>
        <br/><br/>
        <v-row style="display: block;">
          <v-col align="start" style="display: block; text-align: center;">
            <v-btn block rounded height="60" class="primary min-width" v-on:click="saveQuote">Book now</v-btn>
          </v-col>
          <v-col align="end" style="display: block; text-align: center;">
            <v-btn block rounded outlined style="border: 1px solid black;" height="60" class="min-width" v-on:click="sendQuote" :disabled="disabled">Email quote</v-btn>
          </v-col>
        </v-row>
      </div>


      <div v-if="!$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col>
            <h1 class="mb-4">Here's your quote</h1>
          </v-col>
          <v-col align="end">
            <v-btn rounded outlined style="border: 1px solid black;" height="60" class="min-width" v-on:click="sendQuote" :disabled="disabled">Email quote</v-btn>
          </v-col>
          <v-col align="start">
            <v-btn rounded height="60" class="primary min-width" v-on:click="saveQuote">Book now</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card elevation="10" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Delivery</h2>
                    <h2 v-else class="black--text mb-4">Collection</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span>)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p v-if="!isTruckVehicle">
                      Bin placement, collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                    <p v-else>
                      Collection, disposal and landfill dump charges* (VAT inclusive)
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="!isTruckVehicle">
            <v-card elevation="0" height="200" class="grey lighten-4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h2 v-if="!isTruckVehicle" class="black--text mb-4">Exchange</h2>
                  </v-col>
                  <v-col align="end">
                    <h2 class="primary--text"> R {{ vehicle.cost }} </h2> <span>(Fuel levy <span style="font-weight: bold;" class="primary--text">+R{{ fuelLevyPrice }}</span>)</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>
                      Full bin collection and bring a new bin (exchange)
                      Bin exchange, disposal and landfill dump charges* (VAT inclusive)
                      Skip bin rental for 1 - 7 days
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Quote details
          </v-col>
          <v-col align="end">
            #{{ parseInt(order+1) }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : ''">
          <v-col>
            <h4 class="black--text mb-2">Your waste address is </h4>
            {{ capturedAddress }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Waste type </h4>
            {{ wasteType.name }}
          </v-col>
          <v-col>
            <h4 class="black--text mb-2">Service type </h4>
            <span> {{ vehicle.name }} </span>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-col>
</template>

<script>
import Loading from "@/components/Loading";
export default {

  name: "ConfirmInfo",
  props: {
    wasteType: Object,
    vehicle: Object,
    capturedAddress: String,
    location: Object,
    postCode: String
  },
  components:{
    Loading
  },
  data() {
    return {
      booking: {},
      isSendingEmail: false,
      timeStamp: new Date(),
      disabled: false
    }
  },
  methods: {
    sendQuote() {
      this.isSendingEmail = true;
      this.saveQuote();
    },
    sendPipeDriveDeal(){
      let user = {
        name: this.user ? `${this.user.firstName} ${this.user.lastName}` : "NA",
        email: this.user.emailAddress,
        phone: this.user.mobile
      };
      let deal = {
        title: `Quote #${Number.parseInt(this.order) + 1}`,
        value: this.vehicle.cost,
        currency: "ZAR",
        status: "open",
        pipeline_id: 4
      };
      
      this.$store.dispatch("sendPipeDriveDeal", {
        user: user,
        deal: deal
      });
    },
    async saveQuote() {
      // send deal to pipedrive 
      this.sendPipeDriveDeal();

      const isAnonymous = !this.user.id;
      if (isAnonymous) {
        this.buildQuote();
        await this.$store.dispatch('createQuote', this.booking);
      } else {
        this.buildBooking();
        this.disabled = true;
        await this.$store.dispatch('createBooking', this.booking);
      }
    },
    buildBooking() {
      if(this.vehicle.drivers){
        this.buildQuote();
        this.booking = { ...this.booking, userId: this.user.id }
      }
      else{
        alert('Service unavailable. Please select another service');
        this.$router.go();
      }
    },
    buildQuote() {
      this.booking = {
        order: Number.parseInt(this.order + 1),
        orderNumber:{
          id: 1000, //starting the order id at 1000
          number: 1000
        },
        waste: {
          type: this.wasteType.key,
          name: this.wasteType.name
        },
        vehicle: {
          type: this.vehicle.type,
          name: this.vehicle.name
        },
        drivers: this.vehicle.drivers.map(d => d.id),
        driversTokens: this.vehicle.drivers.map(d => d.token ? d.token : ''),
        driverMobiles: this.vehicle.drivers.map(d => '+27' + d.mobile.substring(1,10)),
        customer:{
          mobile: this.user.mobile,
          name: this.user ? this.user.firstName + " " + this.user.lastName : ''
        },
        cost: {
          currency: 'ZAR',
          symbol: 'R',
          value: this.vehicle.cost,
          fuelLevy: this.fuelLevyPrice
          //discount: this.cost
        },
        capturedAddress: this.capturedAddress,
        postCode: this.location.postal_code ? this.location.postal_code : this.postCode,
        lat: this.location.latitude,
        long: this.location.longitude,
        status: {
          type: 'QUOTE',
          status: 'QUOTE'
        },
        timeStamp: this.timeStamp
      };
    }
  },
  computed: {
    loading(){
      return this.$store.getters.getLoading;
    },
    bookingId() {
      return this.$store.getters.getBookingId;
    },
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    quoteId() {
      return this.$store.getters.getQuoteId;
    },
    quoteError() {
      return this.$store.getters.getQuoteError;
    },
    order(){
      return this.$store.getters.getOrder;
    },
    emailStatus() {
      return this.$store.getters.getEmailStatus;
    },
    emailError() {
      return this.$store.getters.getEmailError;
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    emailAddress() {
      return this.user.emailAddress;
    },
    mobile(){
      return this.user.mobile
    },
    isTruckVehicle(){
      if (this.vehicle.name.toLowerCase().includes("truck") || this.vehicle.type.toLowerCase().includes("truck")) {
        return true;
      }
      return false;
    },
    fuelLevyPrice() {
      return this.$store.state.fuelLevy.fuelLevyPrice;
    }
    /*cost(){
      let actualCost = parseFloat(this.vehicle.cost);
      let discountedCost = actualCost - (actualCost * 0.1);
      return discountedCost.toString().includes(".") ? discountedCost.toFixed(2) : discountedCost;
    }*/
  },
  watch: {
    bookingId(id) {
      if (id && !this.isSendingEmail) {
        this.$router.push('/dashboard/quotes');
      } else if (id && this.isSendingEmail) {
        this.isSendingEmail = false;
        this.$store.dispatch('sendBookingEmail', { ...this.booking, emailAddress: this.emailAddress, quoteId: id });
      }
    },
    bookingError(error) {
      console.log(error);
      alert('Booking creation failed');
    },
    emailStatus(status) {
      if (status && this.user) {
        alert(`Email sent to ${this.emailAddress}`);
        this.$router.push('/dashboard/quotes');
      }
      else if(status && !this.user){
        alert(`Email sent to ${this.emailAddress}`);
        this.$router.push('/signup');
      }
    },
    emailError(error) {
      if (error) {
        console.log(error);
        alert(`Failed to send email to ${this.emailAddress}`);
        this.$router.push('/dashboard/quotes');
      }
    }
  },
  mounted(){
    this.$store.dispatch('fetchOrder');
  }
}
</script>

<style scoped>

.min-width {
  width: 150px;
}

</style>